import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition"
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { Zoom } from "slotworks/graphics/animation/base-animations";
import * as TweenJS from "slotworks/utils/tween";
import Point from "slotworks/utils/geom/point";
import { parallel } from "slotworks/utils/race-utils";
import { CenterPivot } from "slotworks/graphics/pixi/group";
import soundManager from "slotworks/sound/sound-manager";

export default class PotWinTransitions extends AbstractSceneTransition {

    private glow1Tween: TweenJS.Tween;
    private glow2Tween: TweenJS.Tween;
    private glow3Tween: TweenJS.Tween;

    private value: PIXI.extras.BitmapText;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.value = Layers.CelebrationContent.getBitmapText("value");
            this.value.visible = false
            Zoom(Layers.CelebrationBackground.container, 0, 2, 100, 0, TweenJS.Easing.Linear.None, 0, new Point(0.48, 0.5))
                .then(() => {
                    this.glow1Tween = new TweenJS.Tween(
                        CenterPivot(Layers.CelebrationBackground.getSprite("glow_1")))
                        .to({ rotation: Math.PI * 2 }, 20000)
                        .repeat(Infinity)
                        .start();

                    this.glow2Tween = new TweenJS.Tween(
                        CenterPivot(Layers.CelebrationBackground.getSprite("glow_2")))
                        .to({ rotation: -Math.PI * 2 }, 30000)
                        .repeat(Infinity)
                        .start();

                    this.glow3Tween = new TweenJS.Tween(
                        CenterPivot(Layers.CelebrationBackground.getSprite("glow_3")))
                        .to({ rotation: Math.PI * 2 }, 60000)
                        .repeat(Infinity)
                        .start();
                });
            resolve(null); // dont wait for tweens                               
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {
            this.stopTweens();
            parallel([
                () => Contract.wrap(() => { soundManager.customEvent("plaque_transition") }),
                () => Zoom(Layers.CelebrationBackground.container, 1, 0, 150, 0, TweenJS.Easing.Linear.None, 0, new Point(0.5, 0.5))
            ]).then(() => resolve(null));
        });
    }

    private stopTweens() {
        if (this.glow1Tween)
            this.glow1Tween.stop();
        this.glow1Tween = null;
        if (this.glow2Tween)
            this.glow2Tween.stop();
        this.glow2Tween = null;
        if (this.glow3Tween)
            this.glow3Tween.stop();
        this.glow3Tween = null;
    }

}